// Deterministically derives a hue (0-359) from a string, so the same input
// always maps to the same color. Useful for generated avatars/labels.
export function stringToHue(str: string): number {
    let hash = 0;

    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
        hash |= 0;
    }

    return Math.abs(hash) % 360;
}
